// extracted by mini-css-extract-plugin
export var box = "CookieConsent-module--box--0555d";
export var content = "CookieConsent-module--content--7158a";
export var options = "CookieConsent-module--options--f06f9";
export var overlay = "CookieConsent-module--overlay--53c1b";